import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StructureListEntryDto } from '@coin/importer/dto/util';
import { Subscription } from 'rxjs';
import { PopupAction } from '@coin/importer/core/util';
import { StructureListService } from '../../../services/organisation-management/structure-list.service';
import { ToastService } from '../../../services/toast/toast.service';
import { FormsModule } from '@angular/forms';
import { V2TextInputComponent, V2ButtonComponent } from '@coin/shared/core/ui-storybook';
import { DropdownComponent } from '@coin/importer/core/feature';

@Component({
  selector: 'importer-structure-list-entry-popup',
  templateUrl: './structure-list-entry-popup.component.html',
  styleUrls: ['./structure-list-entry-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [V2TextInputComponent, FormsModule, DropdownComponent, V2ButtonComponent]
})
export class StructureListEntryPopupComponent implements OnInit {
  matDialogRef = inject<MatDialogRef<StructureListEntryPopupComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private readonly toast = inject(ToastService);
  structureListService = inject(StructureListService);

  Action = PopupAction;
  originalItem = this.data['item'] as StructureListEntryDto;
  action = this.data['action'] as PopupAction;
  acting: string[] = ['X', ''];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: any;
  uploading = false;
  uploadSubscription: Subscription;

  // eslint-disable-next-line no-restricted-syntax
  ngOnInit(): void {
    if (this.data['action'] === PopupAction.New) {
      this.item = {
        TargetOrgCode: '',
        Position: '',
        HeadGid: '',
        Acting: ''
      };
    } else {
      this.item = this.originalItem;
    }
  }

  async create() {
    if (this.validate()) {
      this.trimStringFields();
      await this.structureListService.createEntry(this.item);
    }
    this.structureListService.setTemporaryLog(this.item);
    this.close();
  }

  async update() {
    if (this.validate()) {
      this.trimStringFields();
      this.item = this.item.trim();
      await this.structureListService.updateEntry(this.item);
    }
    this.close();
  }

  async delete() {
    if (this.validate()) {
      await this.structureListService.deleteEntry(this.item.TargetOrgCode);
    }
    this.close();
    window.location.reload();
  }

  close() {
    if (this.uploading) {
      this.cancelUpload();
    } else {
      this.matDialogRef.close();
    }
  }

  private cancelUpload() {
    this.uploadSubscription?.unsubscribe();
    this.uploading = false;
    this.toast.info('Upload cancelled');
  }

  disableComment(): string {
    return ` (no previous uploads)`;
  }

  validate(): boolean {
    for (const [k] of Object.entries(this.item)) {
      if (!this.item[k]) {
        if (k === 'Acting') {
          if (this.item[k] === '') {
            return true;
          }
        }
        return false;
      } else if (this.validateString(this.item[k])) {
        return false;
      }
    }
    return true;
  }

  validateString(str: string): string | null {
    if (!str) {
      return 'cannot be empty';
    }
    if (str && !str.match(/^[A-Za-z0-9][ A-Za-z0-9]*$/)) {
      return 'has invalid characters';
    }
    return null;
  }

  trimStringFields() {
    this.item.TargetOrgCode = this.item.TargetOrgCode.trim();
    this.item.HeadGid = this.item.HeadGid.trim();
  }
}
